package com.shadowings.gero.domain.reminder

import androidx.compose.runtime.Composable

@Composable
actual fun rememberExactAlarmPermissionGranted(): Boolean = true

actual fun openExactAlarmPermissionSettings() = Unit
